export interface IPostCode {
	code: number | string;
	locality: string;
}

export const emptyPostCode: IPostCode = {
	code: "",
	locality: ""
};
